var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9752 13.1951C17.9752 15.3573 16.228 17.1046 14.0657 17.1046C11.9035 17.1046 10.1562 15.3573 10.1562 13.1951C10.1562 11.0329 11.9035 9.28564 14.0657 9.28564C16.228 9.28564 17.9752 11.0329 17.9752 13.1951Z",
    stroke: "#141522",
    strokeWidth: 1.96566,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0644 22.2265C17.9193 22.2265 21.5121 19.955 24.0129 16.0237C24.9957 14.484 24.9957 11.8958 24.0129 10.3561C21.5121 6.42475 17.9193 4.15332 14.0644 4.15332C10.2096 4.15332 6.61678 6.42475 4.11603 10.3561C3.1332 11.8958 3.1332 14.484 4.11603 16.0237C6.61678 19.955 10.2096 22.2265 14.0644 22.2265Z",
    stroke: "#141522",
    strokeWidth: 1.96566,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeVisible);
export default __webpack_public_path__ + "static/media/eyeVisible.c5766fc357d3199c148b2f3cf7f09d2d.svg";
export { ForwardRef as ReactComponent };